import { ComponentType } from 'react';
import AccountMatchingSettings from './components/AccountMatchingSettings';
import EnrollmentSettings from './components/EnrollmentSettings';
import { SUBCATEGORIES } from '../../common/categories';

export const USER_MANAGEMENT_SETTINGS_TABS_TO_CONTENT: Record<string, ComponentType> = {
    [SUBCATEGORIES.ACCOUNT_MATCHING.ID]: AccountMatchingSettings,
    [SUBCATEGORIES.ENROLLMENT_SETTINGS.ID]: EnrollmentSettings
};

export const MAX_TOKENS_TOOLTIP_TEXT =
    'Define the default number of MFA tokens allowed per user across your organization. You can override this setting for individual users on the MFA User Management page.';
export const SEND_MFA_ENROLLMENT_CONFIRMATION_EMAIL_TOOLTIP_TEXT =
    'Sends users a confirmation email upon enrolling to an MFA token';

const ALLOW_ACCESS_TOOLTIP_TEXT = 'Unpaired users will be able to access resources without multi‑factor authentication';
const DENY_ACCESS_TOOLTIP_TEXT =
    'Unpaired users will be blocked when multi‑factor authentication is required by an active policy';

export const UNPAIRED_USER_POLICY_GROUP_OPTIONS = [
    { title: 'Allow access', value: 'allow', tooltipInfo: ALLOW_ACCESS_TOOLTIP_TEXT },
    { title: 'Deny access', value: 'deny', tooltipInfo: DENY_ACCESS_TOOLTIP_TEXT }
];
